const state = {
  user: null,
  tabStorage: false,
  token: "",
  toolBarData: [
    {
      name: "工作台",
      detail:"/home",
      componentName:'home'
    }
  ], // 保存标签button的数组
  cacheView: ['home'], // 保存需要缓存的数组
  orderCount: {},
  // 设计表单
  editForm:{},
  nodeMap: new Map(),
  isEdit: null,
  selectedNode: {},
  selectFormItem: null,
  design:{},
  runningList: [],
  noTakeList: [],
  endList: [],
  diagramMode: 'design',
  readCount:{},
  isCollapsed:false,
  // 顶部栏
  // unreadCount: 0, //未读通知数
};

export default state;
